var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "栏目",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入栏目" },
                            model: {
                              value: _vm.model.colName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colName", $$v)
                              },
                              expression: "model.colName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "内容id",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入内容id" },
                            model: {
                              value: _vm.model.contentId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentId", $$v)
                              },
                              expression: "model.contentId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "内容code",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入内容code" },
                            model: {
                              value: _vm.model.contentCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentCode", $$v)
                              },
                              expression: "model.contentCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "内容名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入内容名称" },
                            model: {
                              value: _vm.model.contentName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentName", $$v)
                              },
                              expression: "model.contentName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "排序",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入排序" },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "状态(published:已发布；nupublished:未发布)",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "status"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                "请输入状态(published:已发布；nupublished:未发布)"
                            },
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "发布时间",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "publishedTime"
                          }
                        },
                        [
                          _c("j-date", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择发布时间" },
                            model: {
                              value: _vm.model.publishedTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "publishedTime", $$v)
                              },
                              expression: "model.publishedTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "发布人id",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "publishedUserId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入发布人id" },
                            model: {
                              value: _vm.model.publishedUserId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "publishedUserId", $$v)
                              },
                              expression: "model.publishedUserId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }